/* Native interactions for the migrated Reischl website. No Base44 runtime. */
(() => {
  const lifecycles = new WeakMap();
  function initReischl(root = document) {
  lifecycles.get(root)?.abort();
  const lifecycle = new AbortController();
  lifecycles.set(root, lifecycle);
  'use strict';
  const $ = (s, r = root) => r?.querySelector(s);
  const $$ = (s, r = root) => [...(r?.querySelectorAll(s) || [])];
  const menu = $('#site-nav'), menuToggle = $('#site-menu-toggle');
  const offer = $('[data-r-offer-dialog]'), offerToggle = $('[data-r-offer-toggle]'), shade = $('[data-r-offer-shade]');
  const menuShade = menu?.previousElementSibling;
  menuShade?.classList.add('reischl-menu-shade');
  let activeDialog = null, returnFocus = null;
  function modal(target, open, trigger) {
    if (open) { returnFocus = trigger || document.activeElement; activeDialog = target; }
    else { activeDialog = null; }
    document.body.classList.toggle('reischl-lock', open);
    if(target.classList.contains('reischl-form-host')){
      target.dataset.visible=String(open);target.setAttribute('role','dialog');target.setAttribute('aria-modal','true');
      if(open&&offer&&!offer.hidden){offer.hidden=true;shade.hidden=true;offerToggle?.setAttribute('aria-expanded','false');}
    } else if (target === menu) {
      target.dataset.open = String(open); target.inert = !open;
      target.setAttribute('aria-hidden', String(!open)); target.setAttribute('aria-modal', String(open));
      menuToggle?.setAttribute('aria-expanded', String(open)); if(menuShade) menuShade.dataset.open = String(open);
    } else { target.hidden = !open; shade.hidden = !open; offerToggle?.setAttribute('aria-expanded', String(open)); }
    if(open) ($('button,input,a[href]',target) || target).focus(); else returnFocus?.focus();
  }
  menuToggle?.addEventListener('click', () => modal(menu,menu.dataset.open !== 'true',menuToggle));
  menuShade?.addEventListener('click',()=>modal(menu,false));
  $('[aria-label="Menü schließen"]',menu)?.addEventListener('click',()=>modal(menu,false));
  $$('a',menu).forEach(a=>a.addEventListener('click',()=>modal(menu,false)));
  if(menu) matchMedia('(min-width:1536px)').addEventListener('change',e=>{if(e.matches&&menu?.dataset.open==='true')modal(menu,false);},{signal:lifecycle.signal});
  offerToggle?.addEventListener('click', event => { if(window.reischlOpenInquiry?.()) event.preventDefault(); });
  $('[aria-label="Angebotsformular schließen"]',offer)?.addEventListener('click',()=>modal(offer,false));
  shade?.addEventListener('click',()=>modal(offer,false));
  if(menu || offer || $('.reischl-form-host')) document.addEventListener('keydown',e=>{
    if(!activeDialog)return;
    if(e.key==='Escape'){e.preventDefault();modal(activeDialog,false);return;}
    if(e.key!=='Tab')return;
    const collectFocusable=root=>$$('*',root).flatMap(el=>[
      ...(el.matches('a[href],button,input,select,textarea,[tabindex="0"]')&&!el.disabled&&el.tabIndex>=0&&el.getClientRects().length?[el]:[]),
      ...(el.shadowRoot?collectFocusable(el.shadowRoot):[])
    ]);
    const focusable=collectFocusable(activeDialog);
    const first=focusable[0], last=focusable.at(-1);
    let focused=document.activeElement;while(focused?.shadowRoot?.activeElement)focused=focused.shadowRoot.activeElement;
    if(e.shiftKey&&focused===first){e.preventDefault();last?.focus();}
    else if(!e.shiftKey&&focused===last){e.preventDefault();first?.focus();}
  },{signal:lifecycle.signal});
  $$('[data-r-disclosure]').forEach(button=>button.addEventListener('click',()=>{
    const open=button.getAttribute('aria-expanded')!=='true', panel=document.getElementById(button.getAttribute('aria-controls'));
    button.setAttribute('aria-expanded',String(open));
    if(panel){panel.style.gridTemplateRows=open?'1fr':'0fr';panel.style.opacity=open?'1':'0';if(panel.className.includes('max-h-'))panel.style.maxHeight=open?'10000px':'0';panel.inert=!open;}
    $('svg',button)?.style.setProperty('transform',open?'rotate(180deg)':'');
  }));
  $$('[data-r-panel]').forEach(panel=>panel.inert=$(`[aria-controls="${panel.id}"]`)?.getAttribute('aria-expanded')!=='true');
  $$('.readmore-toggle').forEach(button=>button.addEventListener('click',()=>{
    const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));
    const root=button.parentElement,content=button.previousElementSibling;
    content?.classList.toggle('readmore-clamp',!open);
    const fade=$('.readmore-fade',root);if(fade)fade.hidden=open;
    const text=[...button.childNodes].find(n=>n.nodeType===Node.TEXT_NODE);if(text)text.textContent=open?'Weniger anzeigen ':'Weiterlesen ';
    $('svg',button)?.style.setProperty('transform',open?'rotate(180deg)':'');
  }));
  $$('button[aria-label="Zurück"],button[aria-label="Weiter"]').forEach(button=>button.addEventListener('click',()=>{
    const track=$('[class*="overflow-x-auto"]',button.parentElement);if(track)track.scrollBy({left:(button.getAttribute('aria-label')==='Weiter'?1:-1)*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  }));
  $$('button[aria-label^="Bild "]').forEach(button=>{
    const group=button.parentElement,track=$('[class*="overflow-x-auto"]',group.parentElement);if(!track)return;
    const dots=$$('button',group);const index=dots.indexOf(button);
    button.addEventListener('click',()=>{const card=track.children[index];track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:'smooth'});});
    if(index===0)track.addEventListener('scroll',()=>{const cards=[...track.children];const nearest=cards.reduce((best,c,i)=>Math.abs(c.offsetLeft-track.offsetLeft-track.scrollLeft)<Math.abs(cards[best].offsetLeft-track.offsetLeft-track.scrollLeft)?i:best,0);dots.forEach((dot,i)=>{dot.style.backgroundColor=i===nearest?'#EF7C21':'#12141633';dot.setAttribute('aria-pressed',String(i===nearest));});},{passive:true});
  });
  const more=$('[data-r-blog-more]');if(more){const cards=$$('[data-r-blog-card]');cards.slice(12).forEach(x=>x.hidden=true);more.hidden=cards.length<=12;more.addEventListener('click',()=>{cards.forEach(x=>x.hidden=false);more.hidden=true;});}
  }
  initReischl();
  document.addEventListener('shopify:section:load', event => initReischl(event.target));
  document.addEventListener('shopify:section:unload', event => { lifecycles.get(event.target)?.abort(); });
})();
